module.exports = {
  PluginManifest: require('./lib/PluginManifest'),
  PluginStore: require('./lib/PluginStore'),
}



//////////////////
// WEBPACK FOOTER
// ./~/graylog-web-plugin/plugin.js
// module id = 221
// module chunks = 0